import styled from 'styled-components';

import { LG_COLOR, WHITE_COLOR } from 'containers/App/constants';

export const HeaderStyles = styled.div`
  position: sticky;
  top: 0;
  background-color: ${WHITE_COLOR};
  z-index: 1049;
  display: flex;
  align-items: center;
  padding: 0 16px 0 0;
  border-bottom: 5px solid ${LG_COLOR};
  width: 100%;
  min-height: 56px;

  .header {
    margin: auto;
    font-size: calc(1.3rem + 1vw);
  }

  .logo-container {
    margin-left: 50px;
  }

  .logo {
    position: absolute;
    top: calc(50% - 10px);
    height: 20px;
    width: auto;
  }

  .navbar-toggler {
    background-color: ${LG_COLOR};
    color: white;
    padding: 5px 5px 5px 2px;
    margin-right: 10px;
    border-bottom-right-radius: 50px;
    border-top-right-radius: 50px;
    cursor: pointer;
  }

  .header-actions {
    position: absolute;
    top: 50%;
    right: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    transform: translateY(-50%);
  }

  @media (max-width: 768px) {
    .header {
      font-size: 1.35rem;
    }

    .header-actions {
      gap: 8px;
    }
  }
`;
